import { useEffect, useRef, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useLocation, useParams } from "react-router-dom";
import {
  CheckUniqueLedgerPayloadType,
  CheckUniqueLegalCustomerSupplierNamePayloadType,
  GetAllLedgersListPayloadType,
  GetAutoUniqueNumberPayloadType,
  GetCustomerSupplierGroupingListPayloadType,
  PaymentOptionsType,
} from "../../../../commonTypes/clientSettingsTypes";
import {
  GetCityListDataPayloadType,
  GetCountryListDataPayloadType,
  GetStateListDataPayloadType,
} from "../../../../commonTypes/masterDataTypes";
import {
  getBankAccountNumberType,
  getGstInfoType,
  verifyPanType,
} from "../../../../commonTypes/serviceTypes";
import { OptionsType } from "../../../../commonTypes/universalTypes";
import useDebounce from "../../../../customHooks/useDebounce";
import {
  checkUniqueLedgerAction,
  checkUniqueLegalCustomerSupplierAction,
  getAllLedgersListAction,
  getAutoUniqueNumberGenerationAction,
  getCustomerSupplierGroupingListAction,
  resetAutoUniqueNumberGenerationData,
  resetLegalNameMessage,
} from "../../../../redux/clientSettings";
import {
  AllLedgersListType,
  CustomerSupplierListType,
} from "../../../../redux/clientSettings/clientSettingTypes";
import {
  getAllCityAction,
  getAllCountryAction,
  getAllStateAction,
  resetCityList,
  resetStateList,
  resetStateListTotalCount,
} from "../../../../redux/masterData";
import { RootState } from "../../../../redux/rootReducers";
import {
  getBankAccountInfoAction,
  getGstInfoAction,
  resetBankAccountDetails,
  resetGstDetails,
  resetPanVerifyData,
  resetServicesError,
  resetServicesSucces,
  resetShippingAddressPanVerifyDetails,
  verifyPanAction,
  verifyShippingAddressPanAction,
} from "../../../../redux/services";
import {
  BankAccountInfoType,
  PanVerifyType,
  gstDetails,
} from "../../../../redux/services/serviceTypes";
import { returnInputFieldLength } from "../../../../utils/commonFunctions";
import { PlusIconCircle } from "../../../Icon";
import {
  CircularAvatar,
  Loader,
  RadioContainer,
  RollingLoader,
  ToggleSwitch,
  UploadModal,
} from "../../../commons";
import { checkingUpdatedValues } from "../Common";
import CustomerSupplierBusinessDetails from "./CustomerSupplierBusinessDetails";
import CustomerSupplierContactDetails from "./CustomerSupplierContactDetails";
import CustomerSupplierShippingAddressDetails from "./CustomerSupplierShippingAddressDetails";
// import  { renderShippingAddress } from "./renderShippingAddress";
import { components, OptionProps } from "react-select";
import { ImageDataType } from "../../../../commonTypes/fileManagerTypes";
import {
  CountryListTypes,
  StateListTypes,
} from "../../../../redux/masterData/masterTypes";
import ImagePreview from "../../../FileManager/Files/ImagePreview";
import CustomerSupplierPaymentDetails from "./CustomerSupplierPaymentDetails";
import Select from "react-select";
import TableToggleSwitch from "../../../commons/TableToggleSwitch";
import { Iicon } from "../../../../assets/images";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export type BusinessDetailsType = {
  gst: string;
  pan: string;
  msmeRegistrationNo: string;
  legalName: string;
  tradeName: string;
  registrationType?: string;
  registrationDate?: string;
  constitutionOfBusiness?: string;
  companyStatus?: string;
  tin?: string;
};

export type ShippingAddressesType = {
  isOpen: boolean;
  isDeleteIcon: boolean;
  legalNameError: string;
  stateError: string;
  gst: string;
  pan: string;
  legalName: string;
  tradeName: string;
  registrationType?: string;
  registrationDate?: string;
  constitutionOfBusiness?: string;
  companyStatus?: string;
  addressTitle?: string;
  address?: string;
  city?: string;
  state?: object | null;
  country?: string;
  mobile?: string;
  telephone?: string;
  email?: string;
  pincode?: string;
  website?: string;
  panDetails?: any;
};

type UniqueType = {
  uniqueNumber?: string | undefined;
};

type CheckUniqueErrorType = {
  uniqueNumberError: string;
  isUniqueError: boolean;
};

export type ContactDetailsType = {
  addressOne: string;
  addressTwo: string;
  city: string;
  pin: string;
  country: string;
  mobile: string;
  telephone: string;
  email: string;
  website: string;
};

type RadioTypes = {
  id: string;
  name: string;
};

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "supplier",
    name: "Supplier",
  },
  {
    id: "customer",
    name: "Customer",
  },
];


const LEDGER_VISIBILITY_OPTIONS: RadioTypes[] = [
  {
    id: "1",
    name: "Yes",
  },
  {
    id: "0",
    name: "No",
  },
];

export const shippingAddresses: ShippingAddressesType[] = [
  {
    isOpen: true,
    isDeleteIcon: false,
    legalNameError: "",
    stateError: "",
    pan: "",
    gst: "",
    legalName: "",
    tradeName: "",
    registrationType: "",
    registrationDate: "",
    constitutionOfBusiness: "",
    companyStatus: "",
    address: "",
    city: "",
    state: {
      value: "",
      label: "Choose State...",
    },
    country: "",
    mobile: "",
    telephone: "",
    email: "",
    pincode: "",
    website: "",
    panDetails: null,
  },
];

type AppProps = {
  handleSubmitData: (data: any) => void;
  history?: any;
  isEdit?: boolean;
  gstFetching?: boolean;
  customerSupplierData?: CustomerSupplierListType;
  isModal?: boolean;
  client_code: number | null;
  company_name?: string;
  success: number | null;
  toggleModal?: () => void;
  customerSupplierFetching?: boolean;
  uniqueLedgerFetching: boolean;
  ledgerMessage: string | null;
  gstEerror?: string | null;
  gstDetails?: gstDetails | null;
  redirectedLedgerId?: string | null;
  shippingGstDetails?: gstDetails | null;
  countryList: CountryListTypes[] | [];
  countryListTotalCount: number;
  countryFetching: boolean;
  stateList: StateListTypes[] | [];
  stateListTotalCount: number;
  stateFetching: boolean;
  cityList: any[] | [];
  cityListTotalCount: number;
  cityFetching: boolean;
  isState: null | boolean;
  isCity: null | boolean;
  panVerifyDetails: PanVerifyType | null;
  shippingAddressPanVerifyDetails: PanVerifyType | null;
  bankAccountDetails: BankAccountInfoType | null;
  dispatchVerifyPanAction: (data: verifyPanType) => void;
  dispatchVerifyShippingAddressPanAction: (data: verifyPanType) => void;
  dispatchGetBankAccountInfoAction: (data: getBankAccountNumberType) => void;
  dispatchCheckUniqueLedgerAction: (data: CheckUniqueLedgerPayloadType) => void;
  dispatchGstDetailsAction?: (data: getGstInfoType) => void;
  dispatchShippingGstDetailsAction?: (data: getGstInfoType) => void;
  dispatchResetGstDetails?: () => void;
  dispatchResetServicesError?: () => void;
  dispatchResetServicesSucces?: () => void;
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) => void;
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) => void;
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) => void;
  dispatchResetStateListTotalCount: () => void;
  dispatchResetStateList: () => void;
  dispatchResetCityList: () => void;
  dispatchResetBankAccountDetails: () => void;
  dispatchResetPanVerifyData: () => void;
  dispatchResetShippingAddressPanVerifyDetails: () => void;
  servicesError: string | null;
  dispatchGetAutoUniqueNumberCheckAction: (
    data: GetAutoUniqueNumberPayloadType
  ) => void;
  autoUniqueNumberGenerationData: any;
  dispatchResetAutoUniqueNumberGenerationData: () => void;
  dispatchGetAllLedgersListAction: (data: any) => void;
  allShowLedgersList: [] | AllLedgersListType[];
  dispatchGetAllCustomerSupplierGroupingListAction: (data: GetCustomerSupplierGroupingListPayloadType) => void;
  customerSupplierGroupingList: any;
};

const CustomerSupplierForm = ({
  handleSubmitData,
  isEdit,
  success,
  customerSupplierData,
  isModal,
  client_code,
  company_name,
  uniqueLedgerFetching,
  toggleModal,
  history,
  ledgerMessage,
  customerSupplierFetching,
  dispatchCheckUniqueLedgerAction,
  dispatchGstDetailsAction,
  gstDetails,
  gstFetching,
  dispatchResetGstDetails,
  gstEerror,
  countryList,
  countryFetching,
  countryListTotalCount,
  stateList,
  stateListTotalCount,
  stateFetching,
  cityList,
  cityListTotalCount,
  isState,
  isCity,
  panVerifyDetails,
  bankAccountDetails,
  shippingAddressPanVerifyDetails,
  dispatchResetServicesError,
  dispatchResetServicesSucces,
  dispatchGetCountryListAction,
  dispatchGetAllStateAction,
  dispatchGetAllCityAction,
  dispatchResetStateListTotalCount,
  dispatchResetStateList,
  dispatchResetCityList,
  dispatchVerifyPanAction,
  dispatchVerifyShippingAddressPanAction,
  dispatchGetBankAccountInfoAction,
  dispatchResetBankAccountDetails,
  dispatchResetPanVerifyData,
  dispatchResetShippingAddressPanVerifyDetails,
  servicesError,
  dispatchGetAutoUniqueNumberCheckAction,
  autoUniqueNumberGenerationData,
  dispatchResetAutoUniqueNumberGenerationData,
  dispatchGetAllLedgersListAction,
  allShowLedgersList,
  dispatchGetAllCustomerSupplierGroupingListAction,
  customerSupplierGroupingList
}: AppProps) => {
  console.log(customerSupplierData,"customerSupplierData")
  const search = useLocation().search;
  const searchData = history?.location?.state?.searchData;

  const clientCodeFromParams = new URLSearchParams(search).get("client_code");
  const companyNameFromParams = new URLSearchParams(search).get("company_name");
  const [unique, setUnique] = useState<UniqueType>({
    uniqueNumber: "",
  });
  const [checkUniqueError, setCheckUniqueError] =
    useState<CheckUniqueErrorType>({
      uniqueNumberError: "",
      isUniqueError: false,
    });

  const { uniqueNumber } = unique;
  const { uniqueNumberError } = checkUniqueError;
  const [ledgerApiMessage, setLedgerApiMessage] = useState<string>("");
  const [sentOverdueEmailStatus, setSentOverdueEmailStatus] = useState(true);

  const [businessDetails, setBusinessDetails] = useState<BusinessDetailsType>({
    gst: "",
    pan: "",
    msmeRegistrationNo: "",
    legalName: "",
    tradeName: "",
    registrationType: "",
    registrationDate: "",
    constitutionOfBusiness: "",
    companyStatus: "",
    tin: "",
  });

  const [contactDetails, setContactDetails] = useState<ContactDetailsType>({
    addressOne: "",
    addressTwo: "",
    city: "",
    pin: "",
    country: "",
    mobile: "",
    telephone: "",
    email: "",
    website: "",
  });

  const [shippingAddressesData, SetShippingAddressesData] = useState<any>(
    JSON.parse(JSON.stringify(shippingAddresses))
  );
  const [gstApi, setGstApi] = useState(false);
  const [submitShippingAddress, setSubmitShippingAddress] = useState(false);
  const [renderShippingAddress, setRenderShippingAddress] = useState(false);
  const token = useSelector((state: RootState) => state.auth.token);
  const uniqueLegalNameFetching = useSelector(
    (state: RootState) => state.clientSettings.uniqueLegalNameFetching
  );
  const uniqueLegalNameMessage = useSelector(
    (state: RootState) => state.clientSettings.uniqueLegalNameMessage
  );
  const [uniqueCheck, setUniqueCheck] = useState<CheckUniqueLedgerPayloadType>({
    client_code: null,
    token,
    ledger_number: undefined,
  });
  const persist = useRef<any>([]);

  let { id }: any = useParams();
  if (isNaN(id)) {
    var id1 = +id.split("?")[0];
  } else {
    id1 = +id;
  }
  const dispatchAction = useDispatch();

  const [radioValue, setRadioValue] = useState<string>("supplier");

  const [formError, setFormError] = useState({
    legalNameError: "",
    addressStateError: "",
    uniqueNumberError: "",
    countryError: "",
    cityError: "",
  });
  const [countrySelectedList, setCountrySelectedList] = useState<any>([]);
  const [finalCountry, setCountry] = useState<any>({
    value: null,
    label: "Select..",
  });
  const [offset, setOffset] = useState<number>(0);
  const [stateOffset, setStateOffset] = useState<number>(0);
  const [cityOffset, setCityOffset] = useState<number>(0);
  const [text, setText] = useState<string>("");
  const [stateText, setStateText] = useState<string>("");
  const [cityText, setCityText] = useState<string>("");
  const [limit, setLimit] = useState<number>(20);
  const [loadCondition, setLoadCondition] = useState(true);
  // state
  const [addressState, setAddressState] = useState<OptionsType>({
    value: null,
    label: "Select...",
  });
  const [finalStateList, setFinalStateList] = useState<any>([]);
  // city
  const [selectedCityList, setSelectedCityList] = useState<any>({
    value: null,
    label: "Select...",
  });
  const [selectedIncomeLedger, setSelectedIncomeLedger] = useState<any>({
    value: null,
    label: "Select...",
  });
  const [selectedExpenseLedger, setSelectedExpenseLedger] = useState<any>({
    value: null,
    label: "Select...",
  });
  const [finalCityList, setFinalCityList] = useState<any>([]);
  const [isApiCall, setIsApiCall] = useState(false);
  const [isApiCityCall, setIsApiCityCall] = useState(false);
  let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
  let blobToken = process.env.REACT_APP_BLOB_TOEKN;
  const [imageDetails, setImageDetails] = useState<ImageDataType>({
    imageUrl: "",
    downloadImage: "",
    fileType: "",
    finalFileName: "",
    updateBy: "",
    updatedAt: "",
  });
  const [paymentDetails, setPaymentDetails] = useState<PaymentOptionsType>({
    online_payment_details: {
      online_payment_link: "",
    },
    cheque_details: {
      cheque_payable_to: "", //STCO Consulting LLP.
    },
    bank_details: {
      account_no: "",
      bank_name: "",
      beneficiary_name: "",
      ifsc_code: "",
      swift_code: "",
      bank_branch_address: "",
      city: "",
      ifscError: "",
    },
    upi_details: {
      upi_file: "",
      upi_number: "",
      upi_image: undefined,
      upi_id: "",
    },
  });
  const [shippingPanIndex, setShippingPanIndex] = useState<number | null>(null);
  const [upiFile, setUpiFile] = useState({});
  const [signature, setSignature] = useState<any>({});
  const [showSignatureUploadModal, setShowSignatureUploadModal] =
    useState<boolean>(false);
  const [showUpiModal, setShowUpiModal] = useState<boolean>(false);
  const [showImagePreview, setShowImagePreview] = useState<boolean>(false);
  const [previewData, setPreviewData] = useState<any[]>([]);
  const [autoUniqueNumberCheck, setAutoUniqueNumberCheck] =
    useState<boolean>(false);
  const [LedgersData, setLedgersData] = useState<[] | AllLedgersListType[]>([]);
  const [isSubLedgerEnabled, setIsSubLedgerEnabled] = useState<boolean>(false);
  const [showParentLedgerDropDown, setShowParentLedgerDropDown] = useState<boolean>(false);
  const [finalParentLedgerList, setFinalParentLedgerList] = useState<any>([]);
  const [parentLedger, setParentLedger] = useState<any>({
    value: null,
    label: "Select Parent Ledger"
  });
  const [parentLedgerError, setParentLedgerError] = useState<string>("");
  const [showInLedgerList, setShowInLedgerList] = useState(LEDGER_VISIBILITY_OPTIONS[0].id);
  const persistFilterCustomerSupplier = history?.location?.state?.filterData;

  useEffect(() => {
    dispatchResetGstDetails?.();
    dispatchResetServicesError?.();
    dispatchResetServicesSucces?.();
    dispatchResetStateListTotalCount();
    dispatchResetStateList();
    dispatchResetCityList();
    dispatchResetBankAccountDetails();
    dispatchResetPanVerifyData();
    dispatchResetShippingAddressPanVerifyDetails();
    dispatchResetAutoUniqueNumberGenerationData();
    setFinalParentLedgerList([]);

    if (token) {
      let finalData = {
        token,
        clientCode: client_code,
        general_settings_type: "ledger_number",
      };
      dispatchGetAutoUniqueNumberCheckAction(finalData);

      let finalIncomeData: any = {
        token,
        client_code,
        data_req: "enabled",
      };
      dispatchGetAllLedgersListAction(finalIncomeData);
    }
  }, []);

  useEffect(() => {
    if (allShowLedgersList?.length) {
      let data = allShowLedgersList?.map((item: any) => {
        let temp = { ...item };
        temp["value"] = item?.ledger_id;
        temp["label"] = `${item?.ledger_name} (${item?.ledger_number})`;
        item = temp;
        return item;
      });
      setLedgersData([...data]);
    } else {
      setLedgersData([]);
    }
  }, [allShowLedgersList]);
  useEffect(() => {
    if (
      paymentDetails?.bank_details?.account_no ||
      paymentDetails?.bank_details?.ifsc_code
    ) {
      dispatchResetBankAccountDetails();
      dispatchResetServicesError?.();
    }
    // eslint-disable-next-line
  }, [
    paymentDetails?.bank_details?.account_no,
    paymentDetails?.bank_details?.ifsc_code,
  ]);

  useEffect(() => {
    if (
      autoUniqueNumberGenerationData &&
      Object.keys(autoUniqueNumberGenerationData)?.length > 0
    ) {
      setAutoUniqueNumberCheck(autoUniqueNumberGenerationData?.is_enable === 1);
    } else {
      setAutoUniqueNumberCheck(false);
    }
  }, [autoUniqueNumberGenerationData]);

  useEffect(() => {
    if (
      shippingAddressPanVerifyDetails &&
      (shippingPanIndex === 0 || shippingPanIndex)
    ) {
      let temp = JSON.parse(JSON.stringify(shippingAddressesData));
      temp[shippingPanIndex]["panDetails"] =
        shippingAddressPanVerifyDetails?.full_name
          ? shippingAddressPanVerifyDetails
          : null;
      SetShippingAddressesData(temp);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shippingAddressPanVerifyDetails]);

  useEffect(() => {
    if (gstApi && gstDetails) {
      setGstApi(false);
      setBusinessDetails((prevState) => ({
        ...prevState,
        gst: gstDetails?.gstin ? gstDetails?.gstin : "",
        legalName: gstDetails?.legal_name_of_business
          ? gstDetails?.legal_name_of_business
          : "",
        tradeName: gstDetails?.trade_name ? gstDetails?.trade_name : "",
        registrationDate: gstDetails?.registration_date
          ? gstDetails?.registration_date
          : "",
        registrationType: gstDetails?.registration_type
          ? gstDetails?.registration_type
          : "",
        constitutionOfBusiness: gstDetails?.constitution_of_business
          ? gstDetails?.constitution_of_business
          : "",
        companyStatus: gstDetails?.status ? gstDetails?.status : "",
      }));
      setContactDetails((prevState) => ({
        ...prevState,
        addressOne: gstDetails?.address1 ? gstDetails?.address1 : "",
        addressTwo: gstDetails?.address2 ? gstDetails?.address2 : "",
        city: gstDetails?.district ? gstDetails?.district : "",
        country: gstDetails?.district ? "India" : "",
        pin: gstDetails?.pincode ? gstDetails?.pincode?.toString() : "",
      }));
      setAddressState(
        gstDetails?.state_code
          ? {
              value: gstDetails?.state_code,
              label: gstDetails?.state_code,
            }
          : { value: "", label: "Choose State..." }
      );
      setFormError((prev) => ({
        ...prev,
        ...(gstDetails?.legal_name_of_business && { legalNameError: "" }),
        ...(gstDetails?.state_code && { addressStateError: "" }),
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gstDetails]);

  useEffect(() => {
    dispatchAction(resetLegalNameMessage());
    if (isEdit && customerSupplierData) {
      setSelectedIncomeLedger({
        value: customerSupplierData?.default_income_ledger_details?.ledger_id,
        label: customerSupplierData?.default_income_ledger_details?.ledger_name,
      });
      setSelectedExpenseLedger({
        value: customerSupplierData?.default_expense_ledger_details?.ledger_id,
        label:
          customerSupplierData?.default_expense_ledger_details?.ledger_name,
      });
      setSentOverdueEmailStatus(
        customerSupplierData?.sent_overdue_email ? true : false
      );
      setBusinessDetails((prevState) => ({
        ...prevState,
        gst: customerSupplierData?.gst_number
          ? customerSupplierData?.gst_number
          : "",
        pan: customerSupplierData?.pan_number
          ? customerSupplierData?.pan_number
          : "",
        tin: customerSupplierData?.tin_number
          ? customerSupplierData?.tin_number
          : "",
        msmeRegistrationNo: customerSupplierData?.msme_registration_no
          ? customerSupplierData?.msme_registration_no
          : "",
        legalName: customerSupplierData?.legal_name
          ? customerSupplierData?.legal_name
          : "",
        tradeName: customerSupplierData?.trade_name
          ? customerSupplierData?.trade_name
          : "",
        registrationDate: customerSupplierData?.registration_date
          ? customerSupplierData?.registration_date
          : "",
        registrationType: customerSupplierData?.registration_type
          ? customerSupplierData?.registration_type
          : "",
        constitutionOfBusiness: customerSupplierData?.constitution_of_business
          ? customerSupplierData?.constitution_of_business
          : "",
        companyStatus: customerSupplierData?.company_status
          ? customerSupplierData?.company_status
          : "",
      }));

      setContactDetails((prevState) => ({
        ...prevState,
        addressOne: customerSupplierData?.address1
          ? customerSupplierData?.address1
          : "",
        addressTwo: customerSupplierData?.address2
          ? customerSupplierData?.address2
          : "",
        pin: customerSupplierData?.pincode
          ? customerSupplierData?.pincode?.toString()
          : "",
        mobile: customerSupplierData?.mobile
          ? customerSupplierData?.mobile
          : "",
        telephone: customerSupplierData?.telephone
          ? customerSupplierData?.telephone
          : "",
        email: customerSupplierData?.email ? customerSupplierData?.email : "",
        website: customerSupplierData?.website
          ? customerSupplierData?.website
          : "",
      }));
      setUnique((prevState: UniqueType) => ({
        ...prevState,
        uniqueNumber: customerSupplierData?.ledger_number
          ? customerSupplierData?.ledger_number.toString()
          : "",
      }));
      if (customerSupplierData?.signature) {
        setSignature(customerSupplierData?.signature);
      } else {
        setSignature({});
      }
      if (customerSupplierData?.payment_details?.upi_details?.upi_image) {
        setUpiFile(
          customerSupplierData?.payment_details?.upi_details?.upi_image
        );
      } else {
        setUpiFile("");
      }

      if (customerSupplierData?.payment_details) {
        setPaymentDetails(customerSupplierData?.payment_details);
      } else {
        setPaymentDetails({
          online_payment_details: {
            online_payment_link: "",
          },
          cheque_details: {
            cheque_payable_to: "",
          },
          bank_details: {
            account_no: "",
            bank_name: "",
            beneficiary_name: "",
            ifsc_code: "",
            swift_code: "",
            bank_branch_address: "",
            city: "",
          },
          upi_details: {
            upi_file: "",
            upi_number: "",
            upi_image: undefined,
            upi_id: "",
          },
        });
      }

      let radioVal = RADIO_OPTIONS.filter(
        (radio) => radio.id === customerSupplierData?.type
      );

      if (customerSupplierData?.country) {
        setCountry({
          value: customerSupplierData?.country?.value,
          label: customerSupplierData?.country?.label,
        });
      }
      if (customerSupplierData?.state) {
        setAddressState({
          value: customerSupplierData?.state?.value,
          label: customerSupplierData?.state?.label,
        });
      }
      if (customerSupplierData?.city) {
        setSelectedCityList({
          value: customerSupplierData?.city?.value,
          label: customerSupplierData?.city?.label,
        });
      }

      setRadioValue(radioVal[0]?.id);
      if(customerSupplierData?.parent_ledger_details){
        setParentLedger({
          value: customerSupplierData?.parent_ledger_details?.parend_id,
          label: customerSupplierData?.parent_ledger_details?.legal_name
        })
      }
      setIsSubLedgerEnabled(customerSupplierData?.make_sub_ledger == 1 ? true : false)
      let showInLedgerListRadioValue = LEDGER_VISIBILITY_OPTIONS.filter(
        (radio) => radio.id == customerSupplierData?.to_show)
      setShowInLedgerList(showInLedgerListRadioValue[0]?.id)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [customerSupplierData]);

  useEffect(() => {
    if (ledgerMessage?.length) {
      setLedgerApiMessage(ledgerMessage);
    }

    if (ledgerMessage?.length && ledgerMessage?.includes("not")) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        isUniqueError: true,
      }));
    } else if (ledgerMessage?.length && !ledgerMessage?.includes("not")) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        isUniqueError: false,
      }));
    }
  }, [ledgerMessage]);

  useEffect(() => {
    if (isEdit) {
      const { uniqueNumberError } = checkUniqueError;
      setLedgerApiMessage("");
      if (uniqueNumberError) {
        setCheckUniqueError((prevState) => ({
          ...prevState,
          uniqueNumberError: "",
        }));
      }
      setUnique((prevState) => ({
        ...prevState,
        uniqueNumber: customerSupplierData?.ledger_number?.toString(),
      }));
      if (customerSupplierData?.shipping_addresses?.length) {
        persist.current = customerSupplierData?.shipping_addresses;
        let arr: any[] = [];
        customerSupplierData?.shipping_addresses?.map((item: any) => {
          arr.push({
            shipping_id: item?.shipping_id,
            addressOne: item?.address1,
            addressTwo: item?.address2,
            city: item?.city,
            isOpen: true,
            isDeleteIcon: false,
            pan: item?.pan_number,
            msmeRegistrationNo: item?.msme_registration_no,
            gst: item?.gst_number,
            legalName: item?.legal_name,
            tradeName: item?.trade_name,
            registrationType: item?.registration_type,
            registrationDate: item?.registration_date,
            constitutionOfBusiness: item?.constitution_of_business,
            companyStatus: item?.company_status,

            state: {
              value: item?.state,
              label: item?.state,
            },
            country: item?.country,
            mobile: item?.mobile,
            telephone: item?.telephone,
            email: item?.email,
            pincode: item?.pincode,
            website: item?.website,
            panDetails: item?.pan_details,
          });
        });
        SetShippingAddressesData(arr);
      } else {
        // setSubmitShippingAddress(true)
        SetShippingAddressesData(JSON.parse(JSON.stringify(shippingAddresses)));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isEdit, customerSupplierData]);

  // country dropdown things
  useEffect(() => {
    const finalCountryData = countryList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (offset > 0) {
      setCountrySelectedList([...countrySelectedList, ...finalCountryData]);
    } else {
      setCountrySelectedList(finalCountryData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [countryList]);

  useEffect(() => {
    if (token) {
      let finalCountryData = {
        token,
        offset,
        limit,
        search_term: text,
      };
      if (offset <= countryListTotalCount) {
        dispatchGetCountryListAction(finalCountryData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset]);

  const fetchNewData = (search: string) => {
    const finalData = {
      token,
      offset,
      limit,
      search_term: text,
    };
    dispatchGetCountryListAction(finalData);
  };

  useDebounce(
    () => {
      if (text) {
        fetchNewData(text);
      } else {
        const finalData = {
          token,
          offset,
          limit,
          search_term: text,
        };
        dispatchGetCountryListAction(finalData);
      }
    },
    500,
    [text]
  );

  const handleChangeCountry = (data: any) => {
    setCountry({
      value: data?.value,
      label: data?.label,
    });

    if (data?.value && formError.countryError) {
      setFormError((prevState) => ({
        ...prevState,
        countryError: "",
      }));
    }
    setFormError((prevState) => ({
      ...prevState,
      addressStateError: "",
    }));
  };

  const onMenuClose = () => {
    setLoadCondition(true);
  };

  const Option = (props: any) => {
    const { data } = props;
    return (
      <components.Option {...props}>
        <div
          className="d-flex justify-content-sm-start"
          style={{ gap: "10px" }}
        >
          <CircularAvatar
            name={data?.label.split("%")[0]}
            image={data?.image && data?.image}
          />
          <div style={{ marginTop: "-3px" }}>
            <span style={{ fontWeight: "500", fontSize: "16px" }}>
              {data?.label.split("%")[0]}
            </span>
            <br></br>
            <span style={{ color: "#6e7491" }}>
              {data?.label.split("%")[1]}
            </span>
          </div>
        </div>
      </components.Option>
    );
  };

  // state dropdown

  useEffect(() => {
    dispatchResetCityList();
    if (finalCountry?.value) {
      let finalData: GetStateListDataPayloadType = {
        token,
        limit,
        offset: stateOffset,
        search_term: stateText,
        country_id: finalCountry.value,
      };

      if (stateOffset === 0) {
        dispatchGetAllStateAction(finalData);
        setIsApiCall(true);
      } else {
        dispatchGetAllStateAction(finalData);
        setStateOffset(0);
        setIsApiCall(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [finalCountry?.value]);

  useEffect(() => {
    dispatchResetCityList();
    if (isState === false && !stateFetching && finalCountry?.value) {
      let finalData: GetCityListDataPayloadType = {
        token,
        limit,
        offset: cityOffset,
        search_term: cityText,
        country_id: finalCountry.value,
      };
      if (cityOffset === 0) {
        dispatchGetAllCityAction(finalData);
      } else {
        setCityOffset(0);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isState]);

  useEffect(() => {
    const finalStateData = stateList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (stateOffset > 0) {
      setFinalStateList([...finalStateList, ...finalStateData]);
    } else {
      setFinalStateList(finalStateData);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateList]);

  useEffect(() => {
    dispatchResetCityList();
    if (token && stateOffset != 0) {
      let finalStateData = {
        token,
        offset: stateOffset,
        limit,
        search_term: stateText,
        country_id: finalCountry?.value,
      };
      if (stateOffset <= stateListTotalCount) {
        dispatchGetAllStateAction(finalStateData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [stateOffset]);

  // sub-ledger toggle change
  useEffect(() => {
    if(isSubLedgerEnabled === true){
      setShowParentLedgerDropDown(true)
    }
    else{
    setShowParentLedgerDropDown(false)
    }
  }, [isSubLedgerEnabled]);

  // parent ledger api calling

  useEffect(() => {
    if(isSubLedgerEnabled === true){
      const finalData = {
        clientCode: client_code ? client_code : clientCodeFromParams,
        type: radioValue,
        token,
      };
      dispatchGetAllCustomerSupplierGroupingListAction(finalData);
    }
  }, [isSubLedgerEnabled])

  // parent ledger dropdown
  useEffect(() => {
    renderDropDownList();
  }, [customerSupplierGroupingList]);
   
  const renderDropDownList= () => {
    let finalDropDownData: any = [];
    customerSupplierGroupingList?.map((tempData: any) => {
      if(!tempData?.to_show) {
        finalDropDownData?.push({
          level: 1,
          value: tempData?.ledger_id,
          label: tempData?.legal_name,
        });
      }
      if(tempData?.is_tree) {
        tempData?.tree_data?.map((tree: any) => {
          if(!tree?.to_show) {
            finalDropDownData?.push({
              level: 2,
              value: tree?.ledger_id,
              label: tree?.legal_name,
            });
          }
          if(tree?.is_tree) {
            tree?.tree_data?.map((treeD: any) => {
              if(!treeD?.to_show) {
                finalDropDownData?.push({
                  level: 3,
                  value: treeD?.ledger_id,
                  label: treeD?.legal_name,
                });
              }
              if(treeD?.is_tree) {
                treeD?.tree_data?.map((treeD1: any) => {
                  if(!treeD1?.to_show) {
                    finalDropDownData?.push({
                      level: 4,
                      value: treeD1?.ledger_id,
                      label: treeD1?.legal_name,
                    });
                  }
                });
              }
            });
          }
        });
      }
    });
    setFinalParentLedgerList(finalDropDownData);
  }

  const fetchData = (search: string) => {
    const finalData = {
      token,
      offset: stateOffset,
      limit,
      search_term: stateText,
      country_id: finalCountry?.value,
    };

    dispatchGetAllStateAction(finalData);
  };

  useDebounce(
    () => {
      if (stateText && isApiCall) {
        fetchData(stateText);
      } else if (isApiCall) {
        const finalData = {
          token,
          offset: stateOffset,
          limit,
          search_term: stateText,
          country_id: finalCountry?.value,
        };

        dispatchGetAllStateAction(finalData);
      }
    },
    500,
    [stateText]
  );

  const handleChangeState = (data: any) => {
    setAddressState({
      value: data?.value,
      label: data?.label,
    });

    if (data?.value && formError.addressStateError) {
      setFormError((prevState) => ({
        ...prevState,
        addressStateError: "",
      }));
    }
    setFormError((prevState) => ({
      ...prevState,
      cityError: "",
    }));
  };

  //  city

  useEffect(() => {
    let finalData: GetCityListDataPayloadType = {
      token,
      limit,
      offset: cityOffset,
      search_term: cityText,
      state_id: addressState?.value,
    };
    if (addressState?.value) {
      if (cityOffset === 0) {
        dispatchGetAllCityAction(finalData);
        setIsApiCityCall(true);
      } else {
        dispatchGetAllCityAction(finalData);
        setCityOffset(0);
        setIsApiCityCall(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addressState?.value]);

  useEffect(() => {
    const finalCityData = cityList?.map((data: any) => {
      return {
        value: data?.id,
        label: data?.name,
      };
    });
    if (cityOffset > 0) {
      setFinalCityList([...finalCityList, ...finalCityData]);
    } else {
      setFinalCityList(finalCityData);
    }
  }, [cityList]);

  useEffect(() => {
    if (token && cityOffset !== 0) {
      let finalcityData = {
        token,
        offset: cityOffset,
        limit,
        search_term: cityText,
        state_id: addressState?.value,
      };
      if (cityOffset <= cityListTotalCount) {
        dispatchGetAllCityAction(finalcityData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cityOffset]);

  const fetchCityData = (search: string) => {
    const finalData = {
      token,
      offset: cityOffset,
      limit,
      search_term: cityText,
      state_id: addressState?.value,
    };
    dispatchGetAllCityAction(finalData);
  };

  useDebounce(
    () => {
      if (cityText && isApiCityCall) {
        fetchCityData(cityText);
      } else if (isApiCityCall) {
        const finalData = {
          token,
          offset: cityOffset,
          limit,
          search_term: cityText,
          state_id: addressState?.value,
        };
        dispatchGetAllCityAction(finalData);
      }
    },
    500,
    [cityText]
  );

  const handleChangeCity = (data: any) => {
    setSelectedCityList({
      value: data?.value,
      label: data?.label,
    });

    if (data?.value && formError.cityError) {
      setFormError((prevState) => ({
        ...prevState,
        cityError: "",
      }));
    }
  };

  const handleChangeIncomeLedger = (data: any) => {
    setSelectedIncomeLedger({
      value: data?.value,
      label: data?.ledger_name,
    });
  };
  const handleChangeExpenseLedger = (data: any) => {
    setSelectedExpenseLedger({
      value: data?.value,
      label: data?.ledger_name,
    });
  };

  const handleBusinessDetailsChange = (e: any) => {
    dispatchResetServicesSucces?.();
    e.target.name === "pan" && dispatchResetPanVerifyData();
    if (
      e.target.name === "legalName" ||
      e.target.name === "tradeName" ||
      e.target.name === "msmeRegistrationNo"
    ) {
      setBusinessDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    } else if (e.target.name === "tin") {
      const newValue =
        e.target.value.length > e.target.maxLength
          ? e.target.value.slice(0, e.target.maxLength)
          : e.target.value;
      setBusinessDetails((prevState) => ({
        ...prevState,
        [e.target.name]: newValue,
      }));
    } else {
      setBusinessDetails((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value.toUpperCase(),
      }));
    }
    if (e.target.name === "legalName" && formError.legalNameError) {
      setFormError((prevState) => ({
        ...prevState,
        legalNameError: "",
      }));
    }
  };

  const getGstDetails = (e: any) => {
    e.preventDefault();
    setGstApi(true);
    const finalData = {
      token,
      gstNumber: businessDetails?.gst,
    };
    if (businessDetails?.gst && token) {
      dispatchGstDetailsAction?.(finalData);
    }
  };

  const getPanDetails = (e: any) => {
    e.preventDefault();
    dispatchResetPanVerifyData();
    if (businessDetails?.pan && token) {
      const finalData = {
        token,
        panNo: businessDetails?.pan,
      };
      dispatchVerifyPanAction?.(finalData);
    }
  };

  const getShippingAddressPanDetails = ({ e, pan, i }: any) => {
    e.preventDefault();
    setShippingPanIndex(i);
    dispatchResetShippingAddressPanVerifyDetails();
    if (pan && token) {
      const finalData = {
        token,
        panNo: pan,
      };
      dispatchVerifyShippingAddressPanAction?.(finalData);
    }
  };

  const getBankDetails = (e: any) => {
    e.preventDefault();
    dispatchResetBankAccountDetails();
    dispatchResetServicesError?.();
    if (
      paymentDetails?.bank_details?.ifsc_code &&
      paymentDetails?.bank_details?.account_no &&
      token
    ) {
      const finalData = {
        token,
        ifsc_no: paymentDetails?.bank_details?.ifsc_code,
        account_number: paymentDetails?.bank_details?.account_no,
      };
      dispatchGetBankAccountInfoAction?.(finalData);
    }
  };

  const handleMaxLengthCheck = (e: any) => {
    if (e.target.value.length > e.target.maxLength) {
      e.target.value = e.target.value.slice(0, e.target.maxLength);
      setUnique((prevState) => ({
        ...prevState,
        uniqueNumber: e.target.value,
      }));
    }
  };

  const handleUpiToggleUploadModal = (e: any) => {
    e.preventDefault();
    setShowUpiModal(!showUpiModal);
  };
  const handleSignatureToggleUploadModal = (e: any) => {
    e.preventDefault();
    setShowSignatureUploadModal(!showSignatureUploadModal);
  };
  const handleDeleteUploadedUpi = () => {
    setUpiFile({});
  };
  const handleUpiUploadFile = (data: any) => {
    setUpiFile(data);
    setShowUpiModal(false);
  };
  const handleDeleteUploadedSignature = () => {
    setSignature({});
  };
  const handleSignatureUploadFile = (data: any) => {
    setSignature(data);
    setShowSignatureUploadModal(false);
  };
  const handleOpenPreview = (data: any) => {
    setPreviewData([data]);
    setShowImagePreview(!showImagePreview);
  };

  useEffect(() => {
    if (previewData?.length) {
      setImageDetails({
        ...previewData[0],
        imageUrl: blobBaseUrl + previewData[0].file_url + "?" + blobToken,
        downloadImage: previewData[0].file_url,
        fileType: previewData[0].file_type,
        finalFileName: previewData[0].file_name,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previewData]);
  const handlePreviewImageModal = () => {
    setShowImagePreview(!showImagePreview);
  };

  // Custom Hook for debounce function
  useDebounce(
    () => {
      handleCheckUniqueLegalName();
    },
    500,
    [businessDetails?.legalName]
  );

  const handleCheckUniqueLegalName = () => {
    const { legalName } = businessDetails;
    if (
      legalName &&
      legalName?.length > 0 &&
      customerSupplierData?.legal_name?.toLowerCase() ===
        legalName?.toLowerCase().trim()
    ) {
      dispatchAction(resetLegalNameMessage());
    } else if (legalName && legalName?.length > 0) {
      let finalData: CheckUniqueLegalCustomerSupplierNamePayloadType = {
        client_code: id1,
        legal_name: legalName,
        token,
      };
      dispatchAction(checkUniqueLegalCustomerSupplierAction(finalData));
    }

    if (legalName.length === 0) {
      dispatchAction(resetLegalNameMessage());
    }
  };

  const handleContactDetailsChange = (e: any) => {
    setContactDetails((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSetRadioValue = (value: string) => {
    setRadioValue(value);
  };

  const handleLedgerVisibilityChange = (value: string) => {
    setShowInLedgerList(value);
  };
  const handleStateChange = (state: any) => {
    setAddressState({
      value: state?.value,
      label: state?.label,
    });

    if (formError.addressStateError) {
      setFormError((prevState) => ({
        ...prevState,
        addressStateError: "",
      }));
    }
  };

  const handleResetData = () => {
    setLedgerApiMessage("");
    setUnique((prevState) => ({
      ...prevState,
      uniqueNumber: "",
    }));
    setCheckUniqueError({
      uniqueNumberError: "",
      isUniqueError: false,
    });
  };
  useEffect(() => {
    if (shippingAddressesData?.length === 1) {
      if (
        shippingAddressesData[0]?.legalName &&
        shippingAddressesData[0]?.state?.value
      ) {
        return setSubmitShippingAddress(true);
      } else if (
        !shippingAddressesData[0]?.legalName &&
        !shippingAddressesData[0]?.state?.value
      ) {
        return setSubmitShippingAddress(true);
      } else if (
        shippingAddressesData[0]?.legalName ||
        shippingAddressesData[0]?.state?.value
      ) {
        if (!shippingAddressesData[0]?.legalName) {
          setSubmitShippingAddress(false);
        }
        if (!shippingAddressesData[0]?.state?.value) {
          setSubmitShippingAddress(false);
        }
      }
    } else if (shippingAddressesData?.length > 1) {
      const buttonDisable = shippingAddressesData?.map((e: any) => {
        if (!e?.legalName || !e?.state?.value) {
          return false;
        }
      });
      const filterData = buttonDisable?.filter((e: any) => e === false);
      if (filterData?.length) {
        setSubmitShippingAddress(false);
      } else {
        setSubmitShippingAddress(true);
      }
    } else {
      return setSubmitShippingAddress(true);
    }
  }, [renderShippingAddress, submitShippingAddress, shippingAddressesData]);

  const handleSubmitForm = () => {
    setRenderShippingAddress(!renderShippingAddress);
    if (
      // addressState?.value &&
      // selectedCityList?.value &&
      // finalCountry?.value &&
      businessDetails?.legalName &&
      (uniqueNumber || autoUniqueNumberCheck) &&
      submitShippingAddress &&
      ((isState &&
        addressState?.value &&
        finalCountry?.value &&
        selectedCityList?.value) ||
        (!isState && finalCountry?.value) ||
        (isState && addressState?.value && finalCountry?.value && !isCity))
    ) {
      let tempData = JSON.parse(JSON.stringify(shippingAddressesData));
      tempData?.forEach((data: any) => {
        data.address1 = data?.addressOne?.trim();
        data.address2 = data?.addressTwo?.trim();
        data.city = data?.city;
        data.state = data?.state?.value;
        data.country = data?.country;
        data.mobile = data?.mobile;
        data.telephone = data?.telephone;
        data.email = data?.email?.trim();
        data.pincode = data?.pincode;
        data.website = data?.website?.trim();
        data.legal_name = data?.legalName?.trim();
        data.company_status = data?.companyStatus?.trim();
        data.constitution_of_business = data?.constitutionOfBusiness?.trim();
        data.registration_date = data?.registrationDate?.trim();
        data.registration_type = data?.registrationType?.trim();
        data.trade_name = data?.tradeName?.trim();
        data.pan_number = data?.pan?.trim();
        data.pan_details = data?.panDetails;
        data.msme_registration_no = data?.msmeRegistrationNo?.trim();
        data.gst_number = data?.gst?.trim();
        delete data.isOpen;
        delete data.pan;
        delete data.legalNameError;
        delete data.stateError;
        delete data.legalName;
        delete data.tradeName;
        delete data.gst;
        delete data.registrationType;
        delete data.registrationDate;
        delete data.constitutionOfBusiness;
        delete data.companyStatus;
        delete data.isDeleteIcon;
        delete data.addressOne;
        delete data.addressTwo;
        delete data.panDetails;
      });

      if (isEdit) {
        checkingUpdatedValues(persist, tempData);
        let finalData = {
          type: radioValue,
          ...businessDetails,
          ...contactDetails,
          pan_details:
            panVerifyDetails?.status === "VALID"
              ? panVerifyDetails
              : customerSupplierData?.pan_details?.status === "VALID" &&
                customerSupplierData?.pan_number === businessDetails?.pan
              ? customerSupplierData?.pan_details
              : null,
          payment_details: {
            ...paymentDetails,
            upi_details: { ...paymentDetails?.upi_details, upi_image: upiFile },
            verifyBankDetails: paymentDetails?.bank_details?.ifscError?.length
              ? null
              : bankAccountDetails?.account_exists
              ? bankAccountDetails
              : customerSupplierData?.payment_details?.verifyBankDetails
                  ?.account_exists
              ? customerSupplierData?.payment_details?.verifyBankDetails
              : null,
          },
          shippingAddressesData:
            shippingAddressesData?.length === 1 &&
            (!shippingAddressesData[0]?.legalName ||
              !shippingAddressesData[0]?.state)
              ? []
              : tempData,
          ledger_id: customerSupplierData?.ledger_id,
          state: addressState?.label,
          country: finalCountry?.label,
          city: selectedCityList?.label,
          sentOverdueEmail: sentOverdueEmailStatus ? 1 : 0,
          signature: signature,
          defaultIncomeLedgerId: selectedIncomeLedger?.value,
          defaultExpenseLedgerId: selectedExpenseLedger?.value,
          ledger_number: uniqueNumber?.toString(),
          parentId: parentLedger?.value,
          toShow: +showInLedgerList,
          makeSubLedger: isSubLedgerEnabled == true ? 1 : 0
        };
        handleSubmitData?.(finalData);
      } else {
        let finalData = {
          type: radioValue,
          ...businessDetails,
          ...contactDetails,
          pan_details:
            panVerifyDetails?.status === "VALID" ? panVerifyDetails : null,
          payment_details: {
            ...paymentDetails,
            upi_details: { ...paymentDetails?.upi_details, upi_image: upiFile },
            verifyBankDetails: paymentDetails?.bank_details?.ifscError?.length
              ? null
              : bankAccountDetails?.account_exists
              ? bankAccountDetails
              : null,
          },
          shippingAddressesData:
            shippingAddressesData?.length === 1 &&
            (!shippingAddressesData[0]?.legalName ||
              !shippingAddressesData[0]?.state)
              ? []
              : tempData,
          state: addressState?.label,
          country: finalCountry?.label,
          city: selectedCityList?.label,
          sentOverdueEmail: sentOverdueEmailStatus ? 1 : 0,
          signature: signature,
          defaultIncomeLedgerId: selectedIncomeLedger?.value,
          defaultExpenseLedgerId: selectedExpenseLedger?.value,
          ledger_number: uniqueNumber?.toString(),
          parentId: parentLedger?.value,
          toShow: +showInLedgerList,
          makeSubLedger: isSubLedgerEnabled == true ? 1 : 0
        };
        handleSubmitData?.(finalData);
      }
    } else {
      setFormError((prevState) => ({
        ...prevState,
        ...(!businessDetails?.legalName && {
          legalNameError: "Legal name is required!",
        }),
        ...(!addressState?.value && {
          addressStateError: "Please choose a state!",
        }),
        ...(!finalCountry.value && {
          countryError: "Please choose a country!",
        }),
        ...(!selectedCityList.value && {
          cityError: "Please choose a city!",
        }),
      }));
      setCheckUniqueError((prevState) => ({
        ...prevState,
        ...(!uniqueNumber && {
          uniqueNumberError: "Unique number is required!",
        }),
      }));
    }
  };

  useDebounce(
    () => {
      if (
        uniqueCheck.client_code &&
        uniqueCheck.ledger_number &&
        uniqueCheck.token
      ) {
        dispatchCheckUniqueLedgerAction(uniqueCheck);
      }
    },
    500,
    [uniqueCheck]
  );

  const handlecheckUniqueChange = (e: any) => {
    handleResetData();
    const { uniqueNumberError } = checkUniqueError;
    let targetName = e.target.name;
    if (targetName === "uniqueNumber" && e.target.value.length) {
      let finalData = {
        token,
        client_code,
        ledger_number: e.target.value,
      };
      if (!isEdit) {
        setUniqueCheck(finalData);
      } else if (
        isEdit &&
        targetName === "uniqueNumber" &&
        e.target.value != customerSupplierData?.ledger_number
      ) {
        setUniqueCheck(finalData);
        handleResetData();
      } else {
        handleResetData();
        setUniqueCheck({
          client_code: null,
          token,
          ledger_number: undefined,
        });
      }
    }

    if (targetName === "uniqueNumber") {
      setUnique((prevState) => ({
        ...prevState,
        [e.target.name]: e.target.value,
      }));
    }

    if (targetName === "uniqueNumber" && uniqueNumberError) {
      setCheckUniqueError((prevState) => ({
        ...prevState,
        uniqueNumberError: "",
      }));
    }
  };
  const handleAddAnotherAddress = () => {
    let temp: any = JSON.parse(JSON.stringify(shippingAddressesData));
    if (isEdit) {
      shippingAddresses?.forEach((e: any) => {
        e.isDeleteIcon = true;
      });
      temp.push(...JSON.parse(JSON.stringify(shippingAddresses)));
    } else {
      temp.push(...JSON.parse(JSON.stringify(shippingAddresses)));
    }
    SetShippingAddressesData(temp);
  };

  const handleRemoveRow = (index: any) => {
    let temp = JSON.parse(JSON.stringify(shippingAddressesData));
    temp.splice(index, 1);
    SetShippingAddressesData(temp);
  };

  const handleShippingAddressChange = (
    dataKey: any,
    value: any,
    index: number
  ) => {
    setRenderShippingAddress(!renderShippingAddress);
    let temp = shippingAddressesData;
    temp[index][dataKey] = value;
    SetShippingAddressesData([...temp]);
  };

  const handleGoBack = () => {
    const client_code = clientCodeFromParams;
    const company_name = companyNameFromParams;

    history?.push({
      pathname: `/client-settings/customers-suppliers/${client_code}`,
      state: {
        client_code,
        company_name,
        filterData: { ...persistFilterCustomerSupplier },
        searchData,
      },
    });

    localStorage.removeItem("ledger_id");
    localStorage.removeItem("client_code");
    localStorage.removeItem("company_name");
  };

  const preventEnterKey: any = document.getElementById("formPrevent");
  if (preventEnterKey) {
    preventEnterKey.addEventListener("keydown", (event: any) => {
      if (event.keyCode === 13 || event.which === 13) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    });
  }

  const handleToogleStatusChange = () => {
    setSentOverdueEmailStatus(!sentOverdueEmailStatus);
  };

  const handleSubLedgerToggleChange = () => {
    setIsSubLedgerEnabled(!isSubLedgerEnabled);
    if(isSubLedgerEnabled === false){
      setParentLedger({
        value: null,
        label: "Select Parent Ledger"
      })
    }
  };

  // Formatting Parent Account Dropdowns
  const CustomOptionComponent = (props: any) => {
    return (
      <components.Option {...props}>
        <ul
          className={`ledger-list ${props.data.level === 1
            ? "ledger-list-first"
            : props.data.level === 2
              ? "ledger-list-second"
              : props.data.level === 3
                ? "ledger-list-third"
                : "ledger-list-fourth"
            }`}
        >
          <li>{props.children}</li>
        </ul>
      </components.Option>
    );
  };

  // parent ledger dropdown change

  const handleParentLedgerDropDownChange = (parentLedger: any) => {
    setParentLedger({
      value: parentLedger?.value,
      label: parentLedger?.label
    });
  };

  return (
    <div className="row" id="formPrevent">
      <div className="col-md-12">
        <div className="content-area">
          <div>
            <h5 style={{ fontSize: "18px", color: "#262a44" }}>
              Entity Type & Account Info
            </h5>
            <span
              style={{ fontSize: "15px", color: "#5c6177" }}
              className="mb-1 mt-3"
            >
              Configure customer/supplier details.
            </span>
          </div>
          <div className="form-group">
            <div className="row mt-3">
              <div className="ml-3">
                <label>Choose type</label>
                <div className="mt-3 mb-4">
                  <RadioContainer
                    optionsList={RADIO_OPTIONS}
                    handleSetRadioValue={handleSetRadioValue}
                    radioValue={radioValue}
                  />
                </div>
              </div>
              {!autoUniqueNumberCheck || isEdit ? (
                <div className="col-md-4 ml-5">
                <label
                  htmlFor="uniqueNumber"
                  className={uniqueNumber ? "active" : ""}
                >
                  Enter Unique Number<span className="color-red">*</span>
                </label>
                <div className="d-flex flex-row position-relative">
                  <input
                    type="number"
                    className={`form-control ${
                      !!uniqueNumberError ? "error-border" : null
                    }`}
                    name="uniqueNumber"
                    value={uniqueNumber}
                    autoFocus
                    onChange={(e) => handlecheckUniqueChange(e)}
                    maxLength={12}
                    onInput={handleMaxLengthCheck}
                    onWheel={(event) => event.currentTarget.blur()}
                    disabled={autoUniqueNumberCheck && isEdit}
                  />
                  {uniqueLedgerFetching && <RollingLoader />}
                </div>
                {!!uniqueNumberError && (
                  <small className="text-danger">{uniqueNumberError}</small>
                )}
                {ledgerApiMessage?.includes("not") &&
                  !!uniqueNumber?.length && (
                    <small className="text-danger">
                      Unique number is already in use!
                    </small>
                  )}
              </div>
              ) : null}
            </div>
          </div>
          {/* {!autoUniqueNumberCheck || isEdit ? (
            <form>
              <div className="form-group">
                <div className="row">
                  <div className="col-md-4">
                    <label
                      htmlFor="uniqueNumber"
                      className={uniqueNumber ? "active" : ""}
                    >
                      Enter Unique Number<span className="color-red">*</span>
                    </label>
                    <div className="d-flex flex-row position-relative">
                      <input
                        type="number"
                        className={`form-control ${
                          !!uniqueNumberError ? "error-border" : null
                        }`}
                        name="uniqueNumber"
                        value={uniqueNumber}
                        autoFocus
                        onChange={(e) => handlecheckUniqueChange(e)}
                        maxLength={12}
                        onInput={handleMaxLengthCheck}
                        onWheel={(event) => event.currentTarget.blur()}
                        disabled={autoUniqueNumberCheck && isEdit}
                      />
                      {uniqueLedgerFetching && <RollingLoader />}
                    </div>
                    {!!uniqueNumberError && (
                      <small className="text-danger">{uniqueNumberError}</small>
                    )}
                    {ledgerApiMessage?.includes("not") &&
                      !!uniqueNumber?.length && (
                        <small className="text-danger">
                          Unique number is already in use!
                        </small>
                      )}
                  </div>
                  <div className="col-md-4 form-group mt-3">
                    <label htmlFor=" Status" className="">
                      Over Due Email Status
                    </label>
                    <TableToggleSwitch
                      handleEnableDisableClick={handleToogleStatusChange}
                      status={sentOverdueEmailStatus}
                      tableData={sentOverdueEmailStatus}
                    />
                  </div>
                </div>
                <span className="input-length">
                  {returnInputFieldLength(uniqueNumber?.length, 12)}
                </span>
              </div>
            </form>
          ) : null} */}
          <div className="row">
            <div className="ml-3">
              <label>
                Do you want to show this Customer/Supplier in the Ledger List?
              </label>
              <div className="mt-3 mb-4">
                <RadioContainer
                  optionsList={LEDGER_VISIBILITY_OPTIONS}
                  handleSetRadioValue={handleLedgerVisibilityChange}
                  radioValue={showInLedgerList}
                />
              </div>
            </div>
          </div>

          <div className="row">
            <div className=" mb-2 mt-2 ml-3">
              <label htmlFor="Stage" className=" ms-3">
                Make this a sub-ledger.
              </label>
              <div>
                <div>
                  <div className="mt-2">
                    <ToggleSwitch
                      handleToggleChange={() => handleSubLedgerToggleChange()}
                      isChecked={isSubLedgerEnabled}
                      name="dailyVoucherFilter"
                    />

                    <span className="mt-1 toogleTextLabel hsn-check-toggle-title">
                      {/* {isSubLedgerEnabled ? "Yes" : "No"} */}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            {showParentLedgerDropDown && (
              <div className="col-md-3 mt-2 ml-4">
                <form>
                  <div className="form-group">
                    <div>
                      <label
                        htmlFor="parentLedger"
                        // className={country ? "active" : ""}
                      >
                        Parent Ledger
                      </label>
                      <Select
                        classNamePrefix="react-select"
                        inputProps={{ autoComplete: "nope" }}
                        options={finalParentLedgerList}
                        className={`react-select`}
                        value={parentLedger}
                        onChange={handleParentLedgerDropDownChange}
                        isSearchable
                        components={{ Option: CustomOptionComponent }}
                      />
                    </div>
                    {/* <small className="text-danger">{countryError}</small> */}
                  </div>
                </form>
              </div>
            )}
          </div>

          <div className="row mt-3">
            <div className="col-md-12">
              <h5 style={{ fontSize: "18px", color: "#262a44" }}>
                Billing Details
              </h5>
              <h6
                style={{ fontSize: "13px", color: "#262a44" }}
                className="mb-1 mt-3"
              >
                BUSINESS DETAILS
              </h6>
            </div>
          </div>
          <CustomerSupplierBusinessDetails
            businessDetails={businessDetails}
            handleBusinessDetailsChange={handleBusinessDetailsChange}
            legalNameError={formError?.legalNameError}
            uniqueLegalNameMessage={uniqueLegalNameMessage}
            uniqueLegalNameFetching={uniqueLegalNameFetching}
            getGstDetails={getGstDetails}
            getPanDetails={getPanDetails}
            getBankDetails={getBankDetails}
            gstEerror={gstEerror}
            success={success}
            panVerifyDetails={panVerifyDetails}
            customerSupplierData={customerSupplierData}
          />
          <div className="row">
            <div className="col-md-12">
              <h6
                style={{ fontSize: "13px", color: "#262a44" }}
                className="mb-0 mt-4"
              >
                CONTACT DETAILS
              </h6>
            </div>
          </div>
          <CustomerSupplierContactDetails
            contactDetails={contactDetails}
            handleContactDetailsChange={handleContactDetailsChange}
            addressState={addressState}
            handleStateChange={handleStateChange}
            addressStateError={formError?.addressStateError}
            onMenuClose={onMenuClose}
            Option={Option}
            countrySelectedList={countrySelectedList}
            countryFetching={countryFetching}
            finalCountry={finalCountry}
            setLoadCondition={setLoadCondition}
            setText={setText}
            setOffset={setOffset}
            handleChangeCountry={handleChangeCountry}
            limit={limit}
            handleChangeState={handleChangeState}
            finalStateList={finalStateList}
            stateFetching={stateFetching}
            handleChangeCity={handleChangeCity}
            finalCityList={finalCityList}
            selectedCityList={selectedCityList}
            setCityOffset={setCityOffset}
            setStateOffset={setStateOffset}
            setCityText={setCityText}
            setStateText={setStateText}
            countryError={formError?.countryError}
            cityError={formError?.cityError}
            isState={isState}
            isCity={isCity}
          />
          <CustomerSupplierPaymentDetails
            paymentDetails={paymentDetails}
            setPaymentDetails={setPaymentDetails}
            upiFile={upiFile}
            handleToggleUploadFileModal={handleUpiToggleUploadModal}
            handleDeleteUploadedFile={handleDeleteUploadedUpi}
            handleSignatureToggleUploadModal={handleSignatureToggleUploadModal}
            handleDeleteUploadedSignature={handleDeleteUploadedSignature}
            signature={signature}
            handleOpenPreview={handleOpenPreview}
            getBankDetails={getBankDetails}
            bankAccountDetails={bankAccountDetails}
            customerSupplierData={customerSupplierData}
            servicesError={servicesError}
          />
          <div>
            <h6
              className="mb-0 mt-2 mb-2"
              style={{ fontSize: "16px", color: "#262a44" }}
            >
              SETTINGS
            </h6>
            <span style={{ color: "#5c6177", fontSize: "15px" }}>
              Configure your default preferences and manage key operational
              settings.
            </span>
          </div>
          <div className="row mt-3">
            <div className="col-md-3 form-group">
              <div>
                <label htmlFor="ledger">
                  Nature of Expense
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-filter-invoice">
                        <div>
                          <div className="text-left">
                            Assign the default Ledger Accounts for this Supplier
                            which will appear as pre-filled option while posting
                            entries.
                          </div>
                        </div>
                      </Tooltip>
                    }
                  >
                    <img className="ml-1 pointer" src={Iicon} alt="EyeIcon" />
                  </OverlayTrigger>
                </label>

                <Select
                  onMenuClose={onMenuClose}
                  // components={{ Option }}
                  isSearchable={true}
                  options={LedgersData}
                  isLoading={countryFetching}
                  value={
                    selectedExpenseLedger?.value
                      ? selectedExpenseLedger
                      : { label: "Select..", value: null }
                  }
                  onChange={(e: any) => handleChangeExpenseLedger(e)}
                />
              </div>
            </div>
            <div className="col-md-3 form-group">
              <div>
                <label htmlFor="ledger">
                  Nature of Income
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-filter-invoice">
                        <div>
                          <div className="text-left">
                            Assign the default Ledger Accounts for this Supplier which will appear as pre-filled option while posting entries.
                          </div>
                        </div>
                      </Tooltip>
                    }
                  >
                    <img className="ml-1 pointer" src={Iicon} alt="EyeIcon" />
                  </OverlayTrigger>
                </label>

                <Select
                  onMenuClose={onMenuClose}
                  isSearchable={true}
                  options={LedgersData}
                  value={
                    selectedIncomeLedger?.value
                      ? selectedIncomeLedger
                      : { label: "Select..", value: null }
                  }
                  onChange={(e: any) => handleChangeIncomeLedger(e)}
                />
              </div>
            </div>
            <div className="col-md-4 form-group ">
              <label htmlFor=" Status" className="mb-2">
                Over Due Email Status
                <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-filter-invoice">
                        <div>
                          <div className="text-left">
                            Once enabled sends payment reminder emails every 3 days for overdue invoices .
                          </div>
                        </div>
                      </Tooltip>
                    }
                  >
                    <img className="ml-1 pointer" src={Iicon} alt="EyeIcon" />
                  </OverlayTrigger>
              </label>
              <TableToggleSwitch
                handleEnableDisableClick={handleToogleStatusChange}
                status={sentOverdueEmailStatus}
                tableData={sentOverdueEmailStatus}
              />
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <h5
                style={{ fontSize: "18px", color: "#262a44" }}
                className="mb-0 mt-4 mb-1"
              >
                Shipping Address Details
              </h5>
            </div>
          </div>

          <div className="row">
            <div className="col-md-12">
              <CustomerSupplierShippingAddressDetails
                shippingAddressesData={shippingAddressesData}
                handleRemoveRow={handleRemoveRow}
                handleShippingAddressChange={handleShippingAddressChange}
                SetShippingAddressesData={SetShippingAddressesData}
                reRenderShippingAddress={renderShippingAddress}
                setRenderShippingAddress={setRenderShippingAddress}
                isEdit={isEdit}
                getShippingAddressPanDetails={getShippingAddressPanDetails}
                customerSupplierData={customerSupplierData}
              />
            </div>
          </div>
          <div className="row mt-3">
            <div className="col-md-12">
              <button
                className="btn btn-outline"
                onClick={handleAddAnotherAddress}
              >
                <span>
                  <PlusIconCircle /> Add Shipping Address
                </span>
              </button>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-12 text-right">
            <button
              className="btn btn-link"
              onClick={
                !!isModal
                  ? toggleModal
                  : () => {
                      clientCodeFromParams
                        ? handleGoBack()
                        : history?.push({
                            pathname: `/client-settings/customers-suppliers/${client_code}`,
                            state: {
                              client_code,
                              company_name,
                              filterData: { ...persistFilterCustomerSupplier },
                              searchData,
                            },
                          });
                      SetShippingAddressesData([]);
                    }
              }
            >
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={handleSubmitForm}
              disabled={
                (!autoUniqueNumberCheck && !uniqueNumber?.trim()?.length) ||
                (isSubLedgerEnabled === true && !parentLedger?.value) ||
                (!autoUniqueNumberCheck && !!uniqueNumberError) ||
                !!customerSupplierFetching ||
                (!autoUniqueNumberCheck && ledgerApiMessage?.includes("not")) ||
                !submitShippingAddress
              }
            >
              {isEdit ? "Update Details" : "Add Details"}
            </button>
          </div>
        </div>
      </div>
      {showUpiModal && (
        <UploadModal
          modal={showUpiModal}
          toggleModal={handleUpiToggleUploadModal}
          client_code={client_code}
          token={token}
          handleUploadFile={handleUpiUploadFile}
          isDraggableModal
          acceptedFiles={"image/png, image/jpeg"}
          maxFileSize={2000000}
          supportedFiles="JPG/PNG"
        />
      )}
      {showSignatureUploadModal && (
        <UploadModal
          modal={showSignatureUploadModal}
          toggleModal={handleSignatureToggleUploadModal}
          client_code={client_code}
          token={token}
          handleUploadFile={handleSignatureUploadFile}
          isDraggableModal
          acceptedFiles={"image/png, image/jpeg"}
          maxFileSize={1000000}
          supportedFiles="JPG/PNG"
        />
      )}
      {showImagePreview && imageDetails?.imageUrl?.length != 0 && (
        <ImagePreview
          resetImageUrl={handlePreviewImageModal}
          imageDetails={imageDetails}
        />
      )}
      {gstFetching && <Loader />}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  ledgerMessage: state.clientSettings.ledgerMessage,
  uniqueLedgerFetching: state.clientSettings.uniqueLedgerFetching,
  error: state.clientSettings.error,
  allLedgersList: state.clientSettings.singleTypeLedgerList,
  gstDetails: state.services.gstDetails,
  shippingGstDetails: state.services.gstDetails,
  gstFetching: state.services.fetching,
  gstEerror: state.services.error,
  success: state.services.success,
  countryList: state.masterData.countryList,
  countryListTotalCount: state.masterData.countryListTotalCount,
  countryFetching: state.masterData.countryFetching,
  stateList: state.masterData.stateList,
  stateListTotalCount: state.masterData.stateListTotalCount,
  stateFetching: state.masterData.stateFetching,
  cityList: state.masterData.cityList,
  cityListTotalCount: state.masterData.cityListTotalCount,
  cityFetching: state.masterData.cityFetching,
  isState: state.masterData.isState,
  isCity: state.masterData.isCity,
  panVerifyDetails: state.services.panVerifyDetails,
  shippingAddressPanVerifyDetails:
    state.services.shippingAddressPanVerifyDetails,
  bankAccountDetails: state.services.bankAccountDetails,
  servicesError: state.services.error,
  autoUniqueNumberGenerationData:
    state.clientSettings.autoUniqueNumberGenerationData,
  allShowLedgersList: state.clientSettings.allShowLedgersList,
  customerSupplierGroupingList: state.clientSettings.customerSupplierGroupingList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchCheckUniqueLedgerAction: (data: CheckUniqueLedgerPayloadType) =>
    dispatch(checkUniqueLedgerAction(data)),
  dispatchGetCountryListAction: (data: GetCountryListDataPayloadType) =>
    dispatch(getAllCountryAction(data)),
  dispatchGetAllStateAction: (data: GetStateListDataPayloadType) =>
    dispatch(getAllStateAction(data)),
  dispatchGetAllCityAction: (data: GetCityListDataPayloadType) =>
    dispatch(getAllCityAction(data)),
  dispatchGstDetailsAction: (data: getGstInfoType) =>
    dispatch(getGstInfoAction(data)),
  dispatchVerifyPanAction: (data: verifyPanType) =>
    dispatch(verifyPanAction(data)),
  dispatchVerifyShippingAddressPanAction: (data: verifyPanType) =>
    dispatch(verifyShippingAddressPanAction(data)),
  dispatchShippingGstDetailsAction: (data: getGstInfoType) =>
    dispatch(getGstInfoAction(data)),
  dispatchGetBankAccountInfoAction: (data: getBankAccountNumberType) =>
    dispatch(getBankAccountInfoAction(data)),
  dispatchResetGstDetails: () => dispatch(resetGstDetails()),
  dispatchResetServicesError: () => dispatch(resetServicesError()),
  dispatchResetServicesSucces: () => dispatch(resetServicesSucces()),
  dispatchResetStateListTotalCount: () => dispatch(resetStateListTotalCount()),
  dispatchResetStateList: () => dispatch(resetStateList()),
  dispatchResetCityList: () => dispatch(resetCityList()),
  dispatchResetBankAccountDetails: () => dispatch(resetBankAccountDetails()),
  dispatchResetPanVerifyData: () => dispatch(resetPanVerifyData()),
  dispatchResetShippingAddressPanVerifyDetails: () =>
    dispatch(resetShippingAddressPanVerifyDetails()),
  dispatchGetAutoUniqueNumberCheckAction: (
    data: GetAutoUniqueNumberPayloadType
  ) => dispatch(getAutoUniqueNumberGenerationAction(data)),
  dispatchResetAutoUniqueNumberGenerationData: () =>
    dispatch(resetAutoUniqueNumberGenerationData()),
  dispatchGetAllLedgersListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getAllLedgersListAction(data)),
  // customer supplier grouping
  dispatchGetAllCustomerSupplierGroupingListAction: (data: GetCustomerSupplierGroupingListPayloadType) => dispatch(getCustomerSupplierGroupingListAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomerSupplierForm);
